import { Card, Flex } from "@jsq/ds/core";
import { FormSelect, FormTextInput } from "@jsq/ds/forms";
import { REPORT_TYPE_CONFIG } from "~/pages/Reporting/ReportTemplateEditor/types";
import { SPACING } from "~/styles/variables";
import { renderFormSelectOptions } from "../../../../shared/DataFormatSection/FormSelectOptions";
import { TransactionTypesField } from "../../../../shared/TransactionTypesField";
import { DECIMAL_PLACES_OPTIONS, FOOTNOTE_SYMBOL_OPTIONS } from "./constants";
import * as styles from "./styles_vanilla.css";
import type { TypeHierarchy } from "../../HierarchyTreeGrid";

type GeneralCardProps = {
  isReadOnly?: boolean;
  typeHierarchy?: TypeHierarchy | null;
};

export const GeneralCard = ({ isReadOnly = false, typeHierarchy = null }: GeneralCardProps) => {
  return (
    <Card isFullWidth title="General">
      <Flex flexDirection="column" gap={SPACING.MEDIUM}>
        <FormTextInput
          name="name"
          label="Query name"
          placeholder="Enter query name"
          className={styles.formControl}
          data-testid="query-settings-name"
          disabled={isReadOnly}
        />
        <FormSelect
          name="supportedTemplateType"
          label="Supported template type"
          className={styles.formControl}
          data-testid="query-settings-supported-template-type"
          disabled
        >
          {renderFormSelectOptions(REPORT_TYPE_CONFIG)}
        </FormSelect>
        <TransactionTypesField
          disabled={isReadOnly}
          typeHierarchy={typeHierarchy}
          data-testid="query-settings-supported-transaction-types"
        />
        <FormSelect
          name="decimalPlaces"
          label="Decimal places"
          className={styles.formControl}
          data-testid="query-settings-decimal-places"
          disabled={isReadOnly}
        >
          {renderFormSelectOptions(DECIMAL_PLACES_OPTIONS)}
        </FormSelect>
        <FormSelect
          name="footnoteSymbol"
          label="Footnote symbol"
          className={styles.formControl}
          data-testid="query-settings-footnote-symbol"
          disabled={isReadOnly}
        >
          {renderFormSelectOptions(FOOTNOTE_SYMBOL_OPTIONS)}
        </FormSelect>
      </Flex>
    </Card>
  );
};
